import { BaseModel } from "sjs-base-model";

export default class RichiestaConcludiRequestModel extends BaseModel {
    public readonly idPreventivo: number = 0;
    public readonly fgDichiarazioneBeneficiario: boolean = false;
    public readonly fgDichiarazioneNonEspostaPolitica: boolean = false;
    public readonly fgDichiarazioneEspostaPolitica: boolean = false;
    public readonly fgDichiarazioneEsigenzePersonali: boolean = false;
    public readonly fgDichiarazioneAltro: boolean = false;
    public readonly isSospensione?: boolean = false;
    public readonly step?: string = "";

    constructor(data: Partial<RichiestaConcludiRequestModel>) {
        super();

        this.update(data);
    }
}
